import moment from 'moment-timezone'
import React from 'react'
import { statusAlarmReturnColor } from '../../enum/statusAlarm'

import { AlarmRiskBollNotification } from '../../styles'
import { TriggerMessageContainer } from './styles'

interface IProps {
    date: number
    status: string
}

export const TriggerLogMessage: React.FC<IProps> = ({ date, status }) => {
    return (
        <TriggerMessageContainer>
            <div className={'time-and-metrics'}>
                <AlarmRiskBollNotification  color={statusAlarmReturnColor(status)} />
                <div className="trigger-date">{moment(new Date(date)).format('LLLL')}</div>
            </div>
        </TriggerMessageContainer>
    )
}
